import React from "react";
import { clsx } from "clsx";
import { AiOutlineTag } from "react-icons/ai";

interface ISeeMoreButtonProps extends React.PropsWithChildren {}

export default function SeeMoreButton(props: ISeeMoreButtonProps) {
  return <div className={clsx("btn", "btn-primary")}>もっと見る</div>;
}
